"use client";

import PullToRefresh from "react-simple-pull-to-refresh";
import { ReactElement } from "react";
import Loader from "@/components/Auth/Common/Loader";
import useSize from "@/hooks/useSize";
import { isIOS } from "react-device-detect";

interface PullToRefreshWrapperProps {
  onRefresh: () => Promise<any>;
  children: ReactElement;
}

const PullToRefreshWrapper: React.FC<PullToRefreshWrapperProps> = ({
  onRefresh,
  children,
}) => {
  const windowSize = useSize();
  const isMobile = windowSize.width < 768;

  // Render the PullToRefresh functionality only on mobile screens and non-iOS devices
  return isMobile && isIOS ? (
    <PullToRefresh
      onRefresh={onRefresh}
      backgroundColor="#171717"
      refreshingContent={
        <div className="h-[80px] w-full flex items-center justify-center">
          <Loader width={42} height={42} />
        </div>
      }
    >
      {children}
    </PullToRefresh>
  ) : (
    <>{children}</>
  );
};

export default PullToRefreshWrapper;
